<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="/" aria-label="Go to home page"
            ><i class="fa fa-home"></i>Home
          </a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          {{ folderName }}
        </li>
      </ol>
    </nav>
    <div class="card">
      <div class="card-header">
        <div class="card-title">Roster</div>
        <div
          v-if="isCurrentMonth"
          class="month-toggle-txt"
          @click="() => { toggleMonthHandler(false); }"
        >
          <i class="fa fa-calendar-check-o" aria-hidden="true"></i> Next Month
        </div>
        <div
          v-else
          class="month-toggle-txt"
          @click="() => { toggleMonthHandler(true); }"
        >
          <i class="fa fa-calendar-check-o" aria-hidden="true"></i> Current Month
        </div>
      </div>
      <div class="card-body">
        <div class="duty-select-bar">
          <div v-if="impersonationShowComputed" class="mb-4">
            <div class="input-group">
              <input
                type="text"
                v-model="impersonate"
                class="form-control"
                placeholder="crew's email"
              />
              <div class="input-group-append">
                <span class="input-group-text">{{ emailDomain }}</span>
              </div>
            </div>
          </div>
          <div class="duty-time-controls">
            <div class="duty-select-box" :class="{ error: validError }">
              <div class="duty-date-label">Start Date</div>
              <div class="position-relative w-100">
                <date-time-input
                  :input-type="'date'"
                  :set-date="rangeStart"
                  :range-date="false"
                  :clearable="false"
                  :min-date="minDate"
                  :max-date="maxDate"
                  @changeDate="(obj) => { changeDate('rangeStart', obj); }"
                />
                <p class="error-txt" v-if="validError">
                  The Start Date should be earlier than the End Date
                </p>
              </div>
            </div>
            <div class="duty-select-box" :class="{ error: validError }">
              <div class="duty-date-label">End Date</div>
              <date-time-input
                :input-type="'date'"
                :set-date="rangeEnd"
                :range-date="false"
                :clearable="false"
                :min-date="minDate"
                :max-date="maxDate"
                @changeDate="(obj) => { changeDate('rangeEnd', obj);}"
              />
            </div>
            <button
              type="button"
              class="btn btn-secondary duty-search-btn"
              aria-label="search"
              :disabled='isLoading'
              @click="searchRoster"
            >
              Search
            </button>
          </div>
          <p class="warn-txt mb-3">
            This is the beta version of the roster view. 
            Please continue to rely on the information in           
            <a
              :href="'https://jxcrew.starlux-airlines.com/jxcrew/login'"
              target="_blank"
              class="text-sm mr-2"
            >
              JX Crew
            </a>
            for duty operations in case of any discrepancies.
          </p>
          <p class="warn-txt mb-4">
            Roster Updated at: {{ currentTime }}
          </p>
        </div>
        <div v-if="roster.length == 0" class="empty-status duty-empty-status">
          <div class="icon"><i class="fa fa-user-times" aria-hidden="true"></i></div>
          <div class="title">No Data found</div>
        </div>
        <div v-if="day.actvType != 99" v-for="(day, dayIdx) in roster" :key="dayIdx" class="mb-5">
          <p class="duty-list-title">{{ day.startDate }}</p>
          <div class="duty-list-item">
            <div
              class="d-flex align-items-center justify-content-between px-4 py-3"
              @click="toggleCollapse(dayIdx)"
            >
              <h4 v-if="day.actvType > 4 && day.actvType !== 9 " class="mb-0 font-weight-bolder">
                {{ day.subActv[0].subActvName }} 
              </h4>
              <h4 v-else class="mb-0 font-weight-bolder">
                {{ day.subActv[0].subActvName }} / {{ day.subActv[0].toAirp }}
                <span class="text-grey"
                  >RPT: {{ day.subActv[0].subSignOnTime }}
                  {{ day.subActv[0].subSignOnTz }}</span>
              </h4>
              <i
                class="duty-list-icon fa fa-angle-left text-grey"
                :style="{
                  transform:
                    isCollapsed == dayIdx ? 'rotate(-90deg)' : 'rotate(0deg)',
                }"
              ></i>
            </div>
            <div v-if="isCollapsed == dayIdx" class="p-4">
              <h4 v-if="day.remarks" class="mb-5 text-grey">Remarks: {{ day.remarks }}</h4>
              <div v-if="task.subActvName != 'LO'" v-for="task in day.subActv" class="mb-4">
                <p class="font-weight-bolder mb-1">{{ task.subActvName }}</p>
                <div v-if="day.actvType < 5 || day.actvType == 9">
                  <h4 v-if="day.actvType == 0 || day.actvType == 3 || day.actvType == 9" class="text-grey">
                    Position: {{ task.position }}
                  </h4>
                  <div v-if="day.actvType == 0">
                    <h4 class="text-grey">Aircraft: {{ task.aircReg }}</h4>
                    <h4 v-if="task.subSignOnDate != null" class="text-grey">
                      RPT: {{ task.subSignOnDate.split('.')[0] }} {{ task.subSignOnTime }} 
                      {{ task.subSignOnTz }}
                    </h4>
                    <table>
                      <tr>
                        <td class="table-left">{{ task.fromAirp }} </td>
                        <td></td>
                        <td class="table-right">{{ task.toAirp }}</td>
                      </tr>
                      <tr class="table-date text-grey">
                        <td class="table-left">{{ task.subStartDate.split('.')[0] }} </td>
                        <td class="table-middle">
                          <i class="fa fa-plane rotate mx-2"></i>
                        </td>
                        <td class="table-right">{{ task.subEndDate.split('.')[0] }}</td>
                      </tr>
                      <tr class="table-time text-grey">
                        <td class="table-left">{{ task.subStartTime }} </td>
                        <td></td>
                        <td class="table-right">{{ task.subEndTime }}</td>
                      </tr>
                    </table>

                    <button
                      class="my-3 crew-list-btn"
                      @click="searchCrewList(task, 'byFlight')"
                    >
                      Crew List
                    </button>
                  </div>
                  <div v-else>
                    <h4 v-if="task.subSignOnDate != null" class="text-grey">
                      RPT: {{ task.subSignOnDate.split('.')[0] }} {{ task.subSignOnTime }} 
                      {{ task.subSignOnTz }}
                    </h4>
                    <table>
                      <tr>
                        <td class="table-left">{{ task.fromAirp }} </td>
                        <td></td>
                        <td class="table-right"></td>
                      </tr>
                      <tr class="table-date text-grey">
                        <td class="table-left">{{ task.subStartDate.split('.')[0] }} </td>
                        <td class="table-middle">
                          <i class="non-flight-actv"> - </i>
                        </td>
                        <td class="table-right">{{ task.subEndDate.split('.')[0] }}</td>
                      </tr>
                      <tr class="table-time text-grey">
                        <td class="table-left">{{ task.subStartTime }} </td>
                        <td></td>
                        <td class="table-right">{{ task.subEndTime }}</td>
                      </tr>
                    </table>

                    <button
                      v-if="day.actvType == 3 || day.actvType == 9"
                      class="my-3 crew-list-btn"
                      @click="searchCrewList(task, 'byCourse')"
                    >
                      Crew List
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CrewListModal
      v-if="crewListShow"
      :id="`${this.currentMission.subActvName + this.currentMission.subStartDate}`"
      :currentMission="currentMission"
      :impersonate="impersonate"
      @crewListModalClose="missionModalClose"
    ></CrewListModal>

    <GroundTrainingListModal
      v-if="trainListShow"
      :currentMission="currentMission"
      :impersonate="impersonate"
      @crewListModalClose="missionModalClose"
    ></GroundTrainingListModal>
  </div>
</template>

<script>
// import { mockData } from '../../mockData/QA20230605';
import DateTimeInput from '@/components/DateTimeInput.vue';
import CrewListModal from '@/components/CrewListModal.vue';
import GroundTrainingListModal from '@/components/GroundTrainingListModal.vue';
import dayjs from 'dayjs';

const timeFormat = 'YYYY-MM-DD';

export default {
  name: 'ThirtyDaySchedule',
  components: {
    DateTimeInput,
    CrewListModal,
    GroundTrainingListModal,
  },
  data: () => ({
    emailDomain: '@starlux-airlines.com',
    folderName: '',
    isCollapsed: null,
    isCurrentMonth: true,
    crewListShow: false,
    trainListShow: false,
    currentMission: {},
    roster: [],
    impersonate: '', //unknown
    rangeStart: dayjs().format(timeFormat),
    rangeEnd: dayjs().add(7, 'day').format(timeFormat)
      ? dayjs().endOf('month').format(timeFormat)
      : dayjs().add(7, 'day').format(timeFormat),
    validError: false,
    isLoading: false,
    currentTime : dayjs().format('YYYY-MM-DD HH:mm:ss')

  }),
  computed: {
    impersonationShowComputed() {
      return this.$store.getters.isImpersonation;
    },
    minDate() {
      return this.isCurrentMonth
        ? dayjs().startOf('month').subtract(1, 'day').format('YYYY-MM-DD')
        : dayjs()
            .add(1, 'month')
            .startOf('month')
            .subtract(1, 'day')
            .format('YYYY-MM-DD');
    },
    maxDate() {
      return this.isCurrentMonth
        ? dayjs().endOf('month').format('YYYY-MM-DD')
        : dayjs().add(1, 'month').endOf('month').format('YYYY-MM-DD');
    },
  },
  methods: {
    toggleMonthHandler(bool) {
      this.isCurrentMonth = bool;
      if (bool) {
        this.rangeStart = dayjs().format(timeFormat);
        this.rangeEnd = dayjs().add(7, 'day').format(timeFormat);
      } else {
        this.rangeStart = dayjs()
          .add(1, 'month')
          .startOf('month')
          .format(timeFormat);
        this.rangeEnd = dayjs()
          .add(1, 'month')
          .startOf('month')
          .add(7, 'day')
          .format(timeFormat);
      }
    },
    toggleCollapse(idx) {
      this.isCollapsed = this.isCollapsed === idx ? null : idx;
    },
    changeDate(key, obj) {
      // console.log(obj);
      let val = obj.value ? dayjs(obj.value).format('YYYY-MM-DD') : null;
      switch (key) {
        case 'rangeEnd': {
          this.rangeEnd = val;
          break;
        }
        case 'rangeStart': {
          this.rangeStart = val;
          break;
        }
      }
    },
    async searchRoster() {
      if (
        dayjs(this.rangeStart).isAfter(this.rangeEnd) ||
        !this.rangeStart ||
        !this.rangeEnd
      ) {
        this.validError = true;
        this.roster = [];
        return false;
      }
      this.validError = false;
      try {
        this.isLoading = true;
        const impersonate = this.impersonate
            ? this.impersonate
            : "";
        const params = {
          rosterStart: dayjs(this.rangeStart).format('YYYY-MM-DD HH:mm:ss'),
          rosterEnd: dayjs(this.rangeEnd).format('YYYY-MM-DD 23:59:59')
        };
        if (impersonate) {
          params.impersonate = impersonate;
        }
        const res = await this.getCrewRosterInfo(localStorage.getItem('access_token'), params);
        this.roster = res.data.data.roster;
        this.currentTime = dayjs().format('YYYY-MM-DD HH:mm:ss');
      } catch (error) {
        // console.log(error);
        this.roster = [];
      }
      this.isLoading = false;
    },
    searchCrewList(currentMission, type) {
      this.currentMission = currentMission;
      type === 'byFlight' ? this.crewListShow = true : this.trainListShow = true;
    },
    missionModalClose() {
      this.currentMission = {};
      this.crewListShow = false;
      this.trainListShow = false;
    },
  },
  async created() {
    this.folderName = this.$route.name;
  },
  async mounted() {
    await this.searchRoster();
  },
};
</script>

<style lang="scss" scoped>
.card {
  min-height: calc(100vh - 180px);
}

.card-body {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 28px;
}

.breadcrumb {
  padding: .75rem 1rem;
  margin-bottom: 1rem;
}

.month-toggle-txt {
  font-size: 14px;
  display: inline-block;
  position: relative;
  padding-bottom: 2px;
  cursor: pointer;
  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: #b99075;
  }
}

.duty-time-controls {
  display: grid;
  grid-template-columns: 2fr 2fr 1fr;
  align-items: center;
  gap: 30px;
  margin-bottom: 3.5rem;
}

.duty-select-box {
  display: flex;
  align-items: center;
  .mx-datepicker {
    width: 100%;
  }

  &.error {
    .mx-datepicker {
      outline: 1px solid #ff5353;
    }
  }
  :deep(.mx-datepicker .form-control) {
    height: 42px;
  }
}

.duty-date-label {
  min-width: 95px;
  font-size: 18px;
}

.duty-search-btn {
  width: fit-content;
  margin-left: auto;
  padding: 5px 15px;
}

.crew-list-btn {
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  color: $brand-primary;
  text-decoration: underline;
  font-size: 16px;
  cursor: pointer;
}

.error-txt {
  color: #ff5353;
  font-size: 12px;
  line-height: 1;
  margin-bottom: 0;
  position: absolute;
  top: 46px;
}

.duty-empty-status {
  padding-top: 7%;
}

.duty-list-title {
  font-weight: 500;
  font-size: 17px;
  padding: 5px 15px;
  background: #f4f4f4;
  border-radius: 8px;
}

.duty-list-item {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 8px;
  margin-bottom: 10px;
}

.duty-list-icon {
  transition: transform 0.3s ease;
  font-size: 1.5em;
}

.rotate {
  transform: rotate(45deg);
}
.input-group-text {
  font-size: 14px;
}
.warn-txt {
  font-size: 12px;
}
.table-date .table-time {
  font-size: 12px;
}
.table-left {
  text-align: left
}
.table-middle {
  text-align: center
}
.table-right {
  text-align: right
}
.fa-plane:before .non-flight-actv {
  margin: 0 10px;
}

@media (max-width: 767px) {
  .duty-time-controls {
    grid-template-columns: 1fr;
    margin-bottom: 2rem;
  }
}
</style>
